const l = {
  name: "Contactless2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17.9,13.6l0.5,0.9c1,1.7,1.5,3.6,1.5,5.5s-0.5,3.8-1.5,5.5l-0.5,0.9l-1.7-1l0.5-0.9c0.8-1.4,1.2-2.9,1.2-4.5
			c0-1.6-0.4-3.1-1.2-4.5l-0.5-0.9L17.9,13.6z"/>
		<path class="st0" d="M14.9,16.5l-0.5-0.9l-1.7,1l0.5,0.9c0.4,0.8,0.7,1.6,0.7,2.5s-0.2,1.7-0.7,2.5l-0.5,0.9l1.7,1l0.5-0.9
			c0.6-1.1,0.9-2.3,0.9-3.5C15.8,18.8,15.5,17.6,14.9,16.5z"/>
		<path class="st0" d="M21.4,11.6l0.5,0.9c1.3,2.3,2,4.9,2,7.5c0,2.6-0.7,5.2-2,7.5l-0.5,0.9l-1.7-1l0.5-0.9c1.2-2,1.8-4.2,1.8-6.5
			c0-2.3-0.6-4.5-1.8-6.5l-0.5-0.9L21.4,11.6z"/>
		<path class="st0" d="M24.9,9.6l0.5,0.9c1.7,2.9,2.6,6.2,2.6,9.5c0,3.3-0.9,6.6-2.6,9.5l-0.5,0.9l-1.7-1l0.5-0.9
			C25.2,25.9,26,23,26,20c0-3-0.8-5.9-2.3-8.5l-0.5-0.9L24.9,9.6z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20c0,11-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20
			c0,9.9,8.1,18,18,18c9.9,0,18-8.1,18-18C38,10.1,29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Contactless2
};
